import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (param) {
  const { isRequestSuccessed, data, exec, ...res } = useRequest({
    url: '',
    name: 'GET_TURNING',
    method: 'GET',
  });

  useEffect(() => {
    if (param && JSON.stringify(param) !== '{}') {
      let url = `/api/devices/${param.device_id}/crafts/${param.id}/dispatch`;
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  return [isRequestSuccessed, data || {}, res.rst];
});
